export default __webpack_public_path__ + "static/media/nodejs.d39adae0.svg";